/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

@Injectable({providedIn: 'root'})
export class AuthenticatedUserService {
  private readonly url = this.apiConfig.getVersionedUri('user');
  private readonly verifyUrl = this.apiConfig.getVersionedUri('user/2fa/verify');
  private readonly sendEmail2faCodeUrl = this.apiConfig.getVersionedUri('user/send-email-2fa-code');
  private readonly changePasswordUrl = this.apiConfig.getVersionedUri('user/change-password');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  sendEmail2faCode(reason: string) {
    return this.send({method: 'GET', url: this.sendEmail2faCodeUrl, params: {reason}}).then(function() {
      return true;
    }).catch(function(response) {
      return {data: response.data};
    });
  }

  changePassword(currentPassword, newPassword, twoFactorAuthCode) {
    const data = {'password': currentPassword, 'newPassword': newPassword, 'twoFactorAuthCode': twoFactorAuthCode};
    return this.send({method: 'POST', url: this.changePasswordUrl, body: data}).then(function(response) {
      return {state: true, data: response};
    }).catch(function(response) {
      return response.data;
    });
  }

  verify2fa(code) {
    return this.send({
      method: 'GET',
      url: this.verifyUrl,
      params: _.merge({context: null, concise: true, useNetworkTags: true}, {code})
    }).then((data) => this.transformProfile(data));
  }

  get(paramOptions?) {
    return this.send({
      method: 'GET',
      url: this.url,
      params: _.merge({context: null, concise: true, useNetworkTags: true}, paramOptions)
    }).then((data) => this.transformProfile(data));
  }

  private transformProfile(data: any): any {
    if (_.isPlainObject(data?.profile)) {
      data.profile = _.mapValues(data.profile, (value: any) => {
        try {
          return JSON.parse(value);
        } catch (ex) {
          return value;
        }
      });
    }
    return data;
  }

  private send(config: any): Promise<any> {
    return firstValueFrom(this.client.request(config));
  }
}
